/**
 * O Exportador responde erro como { "error": "..." }, e nao no envelope IResponse
 * do portal. O useToast() global nao consegue ler esse corpo e cairia sempre em
 * "Ocorreu erro na requisicao!", por isso a tela desliga aquele toast e traduz o
 * status aqui, onde da para diferenciar o contexto da chamada.
 */

export type ContextoErro = 'fornecedores' | 'listagem' | 'download' | 'zip' | 'previa';

export function mensagemDeErro(erro: any, contexto: ContextoErro): string {
  const status = erro && erro.status;

  switch (status) {
    case 400:
      return 'código de fornecedor inválido.';

    case 401:
      // O middleware do Exportador tambem devolve 401 quando o codigo do
      // fornecedor casa com mais de um cadastro ativo em ftp-fornecedores.
      return 'sessão inválida ou cadastro de fornecedor duplicado — contate o suporte.';

    case 403:
      return contexto === 'previa'
        ? 'pré-visualização indisponível para este arquivo — use o download.'
        : 'você não tem acesso aos arquivos deste fornecedor.';

    case 404:
      return contexto === 'zip'
        ? 'este fornecedor não tem arquivos para baixar.'
        : 'arquivo não encontrado — atualize a lista.';

    default:
      return 'não foi possível concluir a operação.';
  }
}
